"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toolbarConfig = exports.removeEmptyParagraph = exports.normalizeSpacing = exports.getToolbarConfig = exports.getMarkupFromEditorState = exports.getEditorState = exports.checkLink = void 0;
var _utils = require("@trs/utils");
var _draftJs = require("draft-js");
var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));
var _htmlToDraftjs = _interopRequireDefault(require("html-to-draftjs"));
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var removeEmptyParagraph = exports.removeEmptyParagraph = function removeEmptyParagraph() {
  var markup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return markup.replace('<p></p>', '');
};

// Trims each paragraph's leading/trailing whitespace, preventing stray edge spaces
// from being saved as "&nbsp;". In-between spacing is left untouched.
var normalizeSpacing = exports.normalizeSpacing = function normalizeSpacing() {
  var markup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return markup.replace(/<p>(?:&nbsp;|\s)+/g, '<p>').replace(/(?:&nbsp;|\s)+<\/p>/g, '</p>').trim();
};
var getEditorState = exports.getEditorState = function getEditorState(value) {
  try {
    if (!value) return _draftJs.EditorState.createEmpty();
    var blocksFromHTML = (0, _htmlToDraftjs["default"])((0, _utils.safeTrim)(value));
    var state = _draftJs.ContentState.createFromBlockArray(blocksFromHTML.contentBlocks);
    return _draftJs.EditorState.createWithContent(state);
  } catch (ex) {
    _utils.Log.warn('Rich text area exception occurred: ', ex);
    return null;
  }
};
var unsafeLinksList = ['<iframe', '</iframe>', '<script', '</script>', '<html', '</html>', 'javascript'];
var checkLink = exports.checkLink = function checkLink(_ref) {
  var target = _ref.target,
    targetOption = _ref.targetOption,
    title = _ref.title;
  var targetCopy = target;
  unsafeLinksList.map(function (item) {
    if (target.includes(item)) {
      targetCopy = targetCopy.replace(item, '');
    }
    return targetCopy;
  });
  return {
    target: targetCopy,
    targetOption: targetOption,
    title: title
  };
};
var toolbarConfig = exports.toolbarConfig = {
  options: ['inline', 'blockType', 'list', 'link'],
  blockType: {
    inDropdown: false,
    options: []
  },
  inline: {
    inDropdown: false,
    options: ['bold', 'italic', 'underline']
  },
  list: {
    inDropdown: false,
    options: ['unordered', 'ordered']
  },
  link: {
    showOpenOptionOnHover: false,
    linkCallback: checkLink
  }
};
var getToolbarConfig = exports.getToolbarConfig = function getToolbarConfig(newProps) {
  return R.isNil(newProps) || R.isEmpty(newProps) ? toolbarConfig : _objectSpread(_objectSpread(_objectSpread({}, toolbarConfig), newProps), {}, {
    options: [].concat(_toConsumableArray(toolbarConfig.options), _toConsumableArray(newProps.options))
  });
};
var getMarkupFromEditorState = exports.getMarkupFromEditorState = function getMarkupFromEditorState(editorState) {
  var rawContentState = (0, _draftJs.convertToRaw)(editorState.getCurrentContent());
  return normalizeSpacing((0, _utils.safeTrim)(removeEmptyParagraph((0, _draftjsToHtml["default"])(rawContentState))));
};